<template>
  <!-- intro-section -->
  <div>
    <dx-header />
    <dx-programa />
    <dx-footer />
  </div>

  <!-- end::intro-section -->
</template>

<script>
import Header from './components/Header.vue'
import Programa from './components/Programa.vue'
import Footer from './components/Footer.vue'

import '@/assets/styles/sass/themes/lite-purple.scss'
import '@/assets/styles/css/landing.css'

export default {
  metaInfo: { bodyAttrs: { class: ['landing-ligth'] } },

  components: {
    dxHeader: Header,
    dxPrograma: Programa,
    dxFooter: Footer,
  },
}
</script>

<style lang="scss">
// @import '@/assets/styles/sass/themes/lite-purple.scss';
</style>
